import { Button } from '@progress/kendo-react-buttons';
import { TextBox } from '@progress/kendo-react-inputs';
import { useState } from 'react';
import { AirportSummaryIFrame } from './AirportSummaryIFrame';
import useAirportSummaryUrl from '../../hooks/use-airport-summary-url';
import { LoadingIndicatorCircular } from '../../components/indicators/LoadingIndicatorCircular';

export default function AirportSummary() {
    const [airportId, setAirportId] = useState<string | null>(null);
    const [inputValue, setInputValue] = useState('');
    const { url, error, loading } = useAirportSummaryUrl(airportId);

    const handleSubmit = () => {
        setAirportId(inputValue);
    };

    return (
        <div className="h-100 d-flex flex-column position-relative">
            <div className="d-flex gap-2 align-items-center justify-content-center p-2">
                <div>Summary for airport: </div>
                <div>
                    <TextBox
                        placeholder="Airport ID"
                        value={inputValue}
                        width={200}
                        onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                        autoFocus
                        onChange={(e) => setInputValue((e.value as string).toUpperCase().trim())}
                    />
                </div>
                <Button onClick={handleSubmit} themeColor={'primary'}>
                    Search
                </Button>
            </div>
            {error && <div className="text-error text-center">{error}</div>}
            {loading && <LoadingIndicatorCircular />}
            {!error && url && <AirportSummaryIFrame url={url} />}
        </div>
    );
}
